import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-enterprise";
import { Campaign } from "../models/Campaign";

const formatDuration = (seconds: number): string => {
	const totalMinutes = Math.floor(seconds / 60);
	const days = Math.floor(totalMinutes / 1440);
	const hours = Math.floor((totalMinutes % 1440) / 60);
	const minutes = totalMinutes % 60;
	const parts: string[] = [];
	if (days > 0) parts.push(`${days}d`);
	if (hours > 0) parts.push(`${hours}h`);
	parts.push(`${minutes}m`);
	return parts.join(" ");
};

export const useHeatListColumns = () => {
	const columnDefs: ColDef[] = [
		{
			field: "HeatName",
			headerName: "Heat",
			minWidth: 60,
			flex: 1,
		},
		{
			field: "SectionName",
			headerName: "Section",
			minWidth: 70,
			flex: 1,
		},
		{
			field: "Start",
			headerName: "Start",
			minWidth: 80,
			flex: 1.5,
			valueGetter: (params) =>
				dxtToLocalServerTime((params.data as Campaign)?.Start, "MM/dd HH:mm") ||
				"",
		},
		{
			field: "Duration",
			headerName: "Duration",
			minWidth: 75,
			flex: 1,
			valueFormatter: (params) => {
				if (params.value == null) return "";
				if (params.value === 0) return "0m";
				return formatDuration(params.value);
			},
		},
		{
			field: "RolledColdTons",
			headerName: "Rolled Tons",
			minWidth: 65,
			flex: 1,
			valueFormatter: (params) => (params.value ? params.value.toFixed(2) : ""),
			cellStyle: {
				justifyContent: "flex-end",
			},
		},
		{
			field: "TonsPerHour",
			headerName: "TPH",
			minWidth: 65,
			flex: 1,
			valueGetter: (params) =>
				(params.data as Campaign)?.TonsPerHour?.toFixed(2),
		},
		{
			field: "DelayTimePercent",
			headerName: "Delays",
			minWidth: 65,
			flex: 1,
			valueFormatter: (params) =>
				params.value == null ? "" : `${params.value.toFixed(0)}%`,
		},
		{
			field: "Cobbles",
			headerName: "Cobbles",
			minWidth: 65,
			flex: 1,
		},
	];
	return { columnDefs };
};
